module.exports = __webpack_public_path__ + "img/co4.35eb7e63.png";